/* This JS triggers animations*/

export function ListReadMore() {
	ListReadMoreInit();
}

let $ = window.jQuery;
let bsdReadMoreBtn = $( '.bsd-read-more' );

function ListReadMoreInit() {

	if ( bsdReadMoreBtn ) {
		hideParagraph();

		$( window ).resize( function () {
			hideParagraph();
		} );

		readMoreBtn();
	}

}

function hideParagraph() {
	const windowWidth = $( window ).width();

	if ( 1024 > windowWidth ) {
		bsdReadMoreBtn.prev().hide();
	} else {
		bsdReadMoreBtn.prev().show();
	}
}

function readMoreBtn() {

	const windowWidth = $( window ).width();

	if ( 1024 > windowWidth ) {
		bsdReadMoreBtn.on( 'click', function () {
			$( this ).prev().slideToggle( 'fast' );
			$( this ).toggleClass( 'bsd-is-expanded' );
		} );
	} else {
		bsdReadMoreBtn.removeClass( 'bsd-is-expanded' );
	}
}
